// only put common error codes
export const API_ERROR_CODE = "REC-API-ERR";
export const NETWORK_ERROR_CODE = "REC-NETWORK-ERR";
export const REC_ERROR_CODE = "REC-ERR";
export const INVALIDATING_CACHE_ERROR_CODE = "INVALIDATING-CACHE-ERR";
export const ADDING_CACHE_ERROR_CODE = "ADDING-CACHE-ERR";
export const FIELD_ERROR_MISSING_ERROR_CODE = "FIELD-ERROR-MISSING-ERR";
